import { atom } from 'jotai';

export const changeStationModalAtom = atom<string | false>(false)
